import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/google-plus-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352zM164 356c57.7 0 96-40.5 96-97.6 0-6.5-0.6-11.6-1.6-16.6h-94.4v34.4h56.9c-2.4 14.6-17.2 43.1-56.8 43.1-34.1 0-61.9-28.3-61.9-63.2 0-35 27.8-63.2 61.9-63.2 19.5 0 32.4 8.3 39.8 15.4l27.1-26.1c-17.5-16.4-40-26.2-67-26.2-55.3 0-100 44.7-100 100s44.7 100 100 100zM384 274.2v-29.2h-29v-29h-29.2v29h-29v29.2h29v29h29.2v-29h29z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/google-plus-square.js
// module id = null
// module chunks = 